<template>
    <div class="row">
        <div class="col-12">
            <template v-if="stat.length === 0">
                <div class="alert text-center" style="background: #ccc;">
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </template>
            <template v-else-if="avgTodayMP25">
                <div class="alert text-center" :style="'color: #fff; background:' + mp25color ">
                    Індекс якості повітря: <strong class="py-5">{{ mp25text }}</strong>
                    <div class="alert alert-light my-2">
                        <strong class="font-weight-bold">
                           {{ avgTodayMP25 }}
                            <!--<small>PM2.5 (µg/m3) </small>-->
                        </strong>
                    </div>
                    <span class="d-block font-italic">{{ pm25detail }}</span>
                    <a href="https://uk.wikipedia.org/wiki/%D0%86%D0%BD%D0%B4%D0%B5%D0%BA%D1%81_%D1%8F%D0%BA%D0%BE%D1%81%D1%82%D1%96_%D0%BF%D0%BE%D0%B2%D1%96%D1%82%D1%80%D1%8F#.D0.9E.D0.B1.D1.87.D0.B8.D1.81.D0.BB.D0.B5.D0.BD.D0.BD.D1.8F_.D1.96.D0.BD.D0.B4.D0.B5.D0.BA.D1.81.D1.83_.D1.8F.D0.BA.D0.BE.D1.81.D1.82.D1.96_.D0.BF.D0.BE.D0.B2.D1.96.D1.82.D1.80.D1.8F"
                       class="aqi-link mt-4"
                       target="_blank">
                      <small> Детальніше про індекс якості повітря</small>
                    </a>
                </div>
            </template>

            <template v-else>
                <div class="alert text-center" :style="'color: #fff; background:' + mp25color ">
                    Індекс якості повітря:
                    <div class="alert alert-light my-2">
                        <strong class="font-weight-bold">
                            Дані відсутні
                        </strong>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>

import _ from "underscore";
import StatService from "@/services/StatService";
import moment from "moment-mini";

export default {
    name: "Aqi",
    props: ["devEUI", "last24HoursStat"],
    data() {
        return {
            stat: []
        }
    },
    methods: {
        async getLast24HoursStat() {
            this.stat = await (new StatService()).getDeviceStat(
                this.devEUI,
                moment().format("YYYY-MM-DD"),
                moment().subtract(24, "hours").format("YYYY-MM-DD")
            );
        }
    },
    computed: {
        avgTodayMP25() {
            let sum = _.reduce(this.stat?.data, (memo, item) => {
                return memo += item.PM25;
            }, 0);

            return Math.round(sum / this.stat?.data?.length);
        },
        pm25detail() {
            if (this.avgTodayMP25 <= 50) return "Мінімальний вплив";
            if (this.avgTodayMP25 > 50 && this.avgTodayMP25 <= 100) return "Може викликати незначний дискомфорт при диханні у чутливих людей.";
            if (this.avgTodayMP25 > 50 && this.avgTodayMP25 <= 100) return "Може спричинити дискомфорт при диханні у людей із захворюваннями легенів, таких як астма, а також у людей з серцевими захворюваннями, дітей і літніх людей.";
            if (this.avgTodayMP25 > 100 && this.avgTodayMP25 <= 200) return "Може викликати дискомфорт при диханні за тривалого впливу, а також дискомфорт у людей із захворюваннями серця.";
            if (this.avgTodayMP25 > 200 && this.avgTodayMP25 <= 300) return "Може викликати дискомфорт при диханні за тривалого впливу, а також дискомфорт у людей із захворюваннями серця.";
            if (this.avgTodayMP25 > 300 && this.avgTodayMP25 <= 400) return "Може викликати респіраторні захворювання у людей при тривалому впливі. Ефект може бути більш виражений у людей з легеневими і серцевими захворюваннями.";
            if (this.avgTodayMP25 > 400) return "Може вплинути навіть на здорових людей, і спричинити серйозні наслідки для здоров'я людей із захворюваннями легень чи серця. Негативні наслідки можуть виникнути навіть під час легкої фізичної активності.";
        },
        mp25text() {
            if (this.avgTodayMP25 <= 50) return "Добрий";
            if (this.avgTodayMP25 > 50 && this.avgTodayMP25 <= 100) return "Задовільний";
            if (this.avgTodayMP25 > 50 && this.avgTodayMP25 <= 100) return "Задовільний";
            if (this.avgTodayMP25 > 100 && this.avgTodayMP25 <= 150) return "Шкідливий для групи ризику";
            if (this.avgTodayMP25 > 150 && this.avgTodayMP25 <= 200) return "Шкідливий";
            if (this.avgTodayMP25 > 200 && this.avgTodayMP25 <= 300) return "Дуже шкідливий";
            if (this.avgTodayMP25 > 300) return "Небезпечний";
        },
        mp25color() {
            if (this.avgTodayMP25 <= 50) return "#03b71f";
            if (this.avgTodayMP25 > 50 && this.avgTodayMP25 <= 100) return "#cfcf02";
            if (this.avgTodayMP25 > 100 && this.avgTodayMP25 <= 150) return "#FF7E00";
            if (this.avgTodayMP25 > 150 && this.avgTodayMP25 <= 200) return "#FF0000";
            if (this.avgTodayMP25 > 200 && this.avgTodayMP25 <= 300) return "#99004C";
            if (this.avgTodayMP25 > 300) return "#7E0023";
            return "#ccc";
        }
    },
    mounted() {
        if(!this.last24HoursStat){
            this.getLast24HoursStat();
        } else {
            this.stat = this.last24HoursStat;
        }
    }
}
</script>

<style lang="less" scoped>

    .aqi-link{
        color: #000;
        text-decoration: underline;
    }


</style>